import { hasActualValue } from '@core/utils/form-utils'
import { AircraftLimit } from '@features/insured/models/coverages/base-coverage.model'

/** The backend only stores entries with aircraft type, limit and currency. */
export function isCompleteAircraftLimit(entry: AircraftLimit): boolean {
  return hasActualValue(entry.aircraftType) && entry.limit.value !== null && hasActualValue(entry.limit.currency)
}

/** An entry someone started filling in; until it is complete it is kept on screen but not saved. */
export function isStartedAircraftLimit(entry: AircraftLimit): boolean {
  return hasActualValue(entry.aircraftType) || entry.limit.value !== null || hasActualValue(entry.limit.currency)
}
